export const START_HOUR = 6;

export const END_HOUR = 23;

export const MIN_CONTIGUOUS_TIMESLOT_DURATION = 2;

export const MIN_REQUIRED_HOURS = 10;
